var map = {
	"./关闭扬声器1.svg": 3094,
	"./关闭扬声器2.svg": 897,
	"./关闭语音.svg": 3829,
	"./办证.svg": 3421,
	"./取消.svg": 2259,
	"./客服.svg": 227,
	"./广播1.svg": 2346,
	"./广播2.svg": 8526,
	"./更多.svg": 4643,
	"./更多服务.svg": 2186,
	"./服务.svg": 9596,
	"./法律服务.svg": 6204,
	"./消息-1.svg": 9931,
	"./消息.svg": 950,
	"./申请.svg": 7469,
	"./电话.svg": 9307,
	"./站点.svg": 120,
	"./视频.svg": 7416,
	"./语音.svg": 4377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;